export interface MessageParticipantContext {
  from?: string | null;
  to?: string | null;
  replyTo?: string | null;
  isDraft?: boolean;
  imapFolder?: { specialUse?: string | null } | null;
}

export function extractMailboxEmail(value: string | null | undefined): string {
  if (!value) return '';

  const angleBracketMatch = value.match(/<([^>]+)>/);
  if (angleBracketMatch?.[1]) return angleBracketMatch[1].trim();

  const emailMatch = value.match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i);
  return (emailMatch?.[0] || value).trim();
}

export function resolveMessageCustomerEmail(
  message: MessageParticipantContext | null | undefined,
): string {
  if (!message) return '';

  const specialUse = message.imapFolder?.specialUse;
  const isOutbound = message.isDraft === true
    || specialUse === '\\Drafts'
    || specialUse === '\\Sent';

  if (isOutbound) return extractMailboxEmail(message.to);

  return extractMailboxEmail(message.replyTo) || extractMailboxEmail(message.from);
}
